const PAYMENT_URL = "https://hotmart.com/es/marketplace/productos/el-mapa-del-trauma/E106711470B";

const BONUSES = [
  {
    n: "01",
    tag: "Hoja de ruta",
    t: "La hoja de ruta clínica que utilizo antes de intervenir",
    d: "Las preguntas que me ayudan a decidir cuándo regular, cuándo esperar y cuándo empezar un procesamiento terapéutico.",
  },
  {
    n: "02",
    tag: "Guía práctica",
    t: "15 preguntas desde el cuerpo para desbloquear sesiones",
    d: "Inspiradas en autores como Pat Ogden. Una herramienta práctica para escuchar lo que el sistema nervioso del paciente intenta expresar.",
  },
  {
    n: "03",
    tag: "Recurso clínico",
    t: "Las 12 técnicas de regulación emocional que utilizo con más frecuencia",
    d: "No solo aprenderás cuáles son. Aprenderás cuándo utilizarlas. Y cuándo no.",
  },
];

export function Bonus() {
  return (
    <section className="bonus-section" data-testid="bonus-section">
      <div className="container">
        <h2 className="section-title reveal">Bonus exclusivos</h2>
        <div className="bonus-grid" data-testid="bonus-grid">
          {BONUSES.map((b, i) => (
            <article className="bonus-card reveal" key={i} data-testid={`bonus-card-${i + 1}`}>
              <div className="bonus-head">
                <span className="bonus-label">Bonus {b.n}</span>
                <span className="bonus-tag">{b.tag}</span>
              </div>
              <h3>{b.t}</h3>
              <p>{b.d}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export function WhoAmI() {
  return (
    <section className="who-section" data-testid="who-section">
      <div className="container who-grid">
        <div className="who-left reveal">
          <figure className="who-photo" data-testid="who-photo">
            <img src="/assets/cristina.webp" alt="Cristina Vidal, psicóloga clínica" />
          </figure>
        </div>
        <div className="who-right reveal">
          <p className="eyebrow">Quién te forma</p>
          <h2 className="section-title">Psicóloga Clínica Cristina Vidal</h2>
          <p className="who-lead">Más de 20 años de experiencia en el ejercicio de una profesión que le apasiona.</p>
          <p>
            Posee 4 másteres, 2 capacitaciones y una larga trayectoria en el sector privado,
            la administración pública y el tercer sector con casos de refugiados de asilo,
            violencia, abusos y en el Servicio de Emergencias Médicas.
          </p>
          <p className="who-highlight">
            Su pasión por la excelencia le ha llevado a ser distinguida por el Gobierno en
            reconocimiento a su labor en el ámbito de la violencia y a obtener el certificado
            de excelencia educativa en 2024 por sus formaciones.
          </p>
          <p>
            Desde hace 15 años dirige sus propios centros de psicología y psiquiatría,
            donde guía a profesionales de su equipo y externos en su práctica clínica.
          </p>
          <p>
            Ha supervisado equipos online de psicólogas con gran visibilidad, así como
            equipos de psicólogas en administraciones públicas.
          </p>
          <p>
            Ha colaborado con reconocidos medios de comunicación como El País, RTVE,
            Atresmedia, Men's Health, elDiario.es, La Vanguardia o El Confidencial,
            consolidándose como una referencia en el sector.
          </p>
          <p>
            Además, su destacada trayectoria clínica ha sido reconocida en los agradecimientos
            de Pearson Clinical España, editorial líder mundial en la publicación y distribución
            de herramientas de evaluación psicológica.
          </p>
        </div>
      </div>
    </section>
  );
}

const TESTIMONIALS = [
  {
    quote:
      "Es el módulo de trauma, que es fantásticoooo. Aprovecho para darte las gracias por toda la información y materiales que se dan, súper práctico.",
    name: "Alumna del módulo de trauma",
    role: "Opinión recibida por WhatsApp",
    initials: "MT",
  },
  {
    quote: "Es una maravilla aprender de tu mano, Cristina. Muchas gracias.",
    name: "@amimisma1738",
    role: "Comentario sobre la formación",
    initials: "A",
  },
  {
    quote:
      "Sus Masterclass son únicas. Me ha ayudado mucho ver la aplicación de conceptos teóricos en sus casos reales. ¡Una profesional con un valor humano inmenso y con una gran experiencia!",
    name: "Diana Ledezma",
    role: "Psicóloga",
    initials: "DL",
  },
  {
    quote:
      "Súper interesante la Masterclass de Trauma. Una clase dinámica donde te enseñan los conceptos básicos teóricos y también las herramientas que puedes aplicar en la práctica. Me ha gustado mucho poder escuchar casos reales que te pueden ayudar a ubicar el diagnóstico y preparar las terapias. Muy, muy recomendable.",
    name: "@patrideltell",
    role: "Comentario sobre la Masterclass de Trauma",
    initials: "P",
  },
  {
    quote:
      "Masterclass altamente recomendable tanto para profesionales como para la población general. Las explicaciones y los casos reales ayudan a entender mejor las implicaciones del trauma y aportan conocimientos muy útiles. Poder verla en directo o en diferido facilita mucho compaginarla con la vida diaria.",
    name: "@cris.serrano.v",
    role: "Comentario sobre la Masterclass de Trauma",
    initials: "CS",
  },
  {
    quote:
      "Muchísimas gracias, Cristina. Ha sido preciosísima la clase. Gracias de corazón por tu entrega y por tu gran calidad. Me siento muy en casa con este enfoque de trabajo.",
    name: "Alumna de la formación",
    role: "Opinión recibida por WhatsApp",
    initials: "AF",
  },
];

export function Testimonials() {
  return (
    <section className="testimonials-section" data-testid="testimonials-section">
      <div className="container">
        <p className="eyebrow reveal">Opiniones sobre la formación en trauma</p>
        <h2 className="section-title reveal">Lo que dicen quienes ya han aprendido con Cristina</h2>
        <p className="testimonials-subtitle reveal">
          Comentarios reales recibidos tras sus clases, masterclass y formaciones sobre trauma.
        </p>
        <div className="testimonials-grid">
          {TESTIMONIALS.map((t, i) => (
            <figure className="testimonial-card reveal" key={i} data-testid={`testimonial-card-${i + 1}`}>
              <svg className="quote-mark" viewBox="0 0 24 24" width="26" height="26" fill="none" aria-hidden="true">
                <path d="M10 7c-3 1-5 3.5-5 7v3h6v-6H8c.3-1.8 1.4-3 3-3.6L10 7zm9 0c-3 1-5 3.5-5 7v3h6v-6h-3c.3-1.8 1.4-3 3-3.6L19 7z" fill="#f2d675" />
              </svg>
              <blockquote>{t.quote}</blockquote>
              <figcaption>
                <span className="testimonial-avatar" aria-hidden="true">{t.initials}</span>
                <span>
                  <strong>{t.name}</strong>
                  <small>{t.role}</small>
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}

export function FinalCTA() {
  return (
    <section className="final-section" data-testid="final-cta-section">
      <div className="container final-layout">
        <div className="final-next reveal">
          <p className="eyebrow">Imagina tu próxima sesión</p>
          <div className="final-next-body">
            <p>Probablemente seguirás utilizando las mismas herramientas.</p>
            <p>Lo que cambiará será la forma de decidir cuándo utilizarlas.</p>
            <p>Y esa diferencia puede cambiar completamente una terapia.</p>
          </div>
          <p className="final-quote" data-testid="next-quote">
            Porque un buen terapeuta conoce técnicas.
            <span> Pero un terapeuta excelente sabe cuándo utilizarlas.</span>
          </p>
        </div>
        <div className="final-cta-card reveal">
          <h2 className="final-title" data-testid="final-title">El mapa del trauma</h2>
          <p className="final-sub">Aprende a ver con claridad antes de intervenir.</p>
          <p className="final-start">Empieza hoy.</p>
          <a href={PAYMENT_URL} className="btn" data-testid="final-cta-button">Quiero aprender a leer el mapa</a>
        </div>
      </div>
    </section>
  );
}

export function Footer() {
  return (
    <footer className="site-footer" data-testid="site-footer">
      <div className="container center">
        <img src="/assets/logo.png" alt="Cristina Vidal · Psicóloga" className="footer-logo" />
        <p>© Cristina Vidal Psicóloga</p>
        <small>[Aviso legal] · [Política de privacidad] · [Contacto]</small>
      </div>
    </footer>
  );
}
